/* istanbul ignore file */
import { FormSection, FormRow, BigFormRow } from 'framework/ui/layout';
import TemplateTypeInput from 'domain/sales/opportunity/presale/contract/shared/input/TemplateTypeInput';
import {
  WysiwygInput,
  useFormContext,
  BooleanRadiosGroup,
  BOOLEAN_RADIUS_GROUP_OPTIONS,
  ClearAfterUnmountWrapper,
} from 'framework/form';
import { ARTIFACT_ID } from 'domain/shared/artifact';
import CompositeDocumentUploaderInput from 'domain/sales/opportunity/shared/storage/components/CompositeDocumentUploaderInput';

const ContractRequestForm = () => {
  const { data } = useFormContext();
  const templateType = data?.templateType;
  const attachmentLabel =
    templateType === 'SYBERRY' ? 'Attach the completed customer form' : 'Attach customer contract template';
  return (
    <FormSection>
      <FormRow>
        <TemplateTypeInput label="Contract Template Type" source="templateType" />
      </FormRow>
      <BigFormRow>
        <WysiwygInput source="descriptionText" label="Description" />
        <ClearAfterUnmountWrapper isVisible={formData => formData?.templateType === 'SYBERRY'}>
          <BooleanRadiosGroup
            options={BOOLEAN_RADIUS_GROUP_OPTIONS}
            source="isCustomerDetailsUnchanged"
            label="The new customer form provided earlier, and  the customer’s details have not changed"
          />
        </ClearAfterUnmountWrapper>
        <CompositeDocumentUploaderInput
          label={attachmentLabel}
          maxElements={15}
          artifactTypeId={ARTIFACT_ID.CRM_ATTACHMENT}
          artifactsListSource={'attachmentsIds'}
          documentsListsSource={'artifactPaths'}
        />
      </BigFormRow>
    </FormSection>
  );
};

export default ContractRequestForm;
